import { klona } from 'klona/full';
export function clone(data) {
    return klona(data);
}
